export default __webpack_public_path__ + "static/media/1657200448619.af7e2905.jpeg";